const routes = [
    {
        path: "/housing/airport-transfer-request/:token",
        component: () => import("../pages/Index"),
    }
];

export default routes;
